<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Uporabniki</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                {{users}}-->
                <vue-good-table
                        styleClass="vgt-table table table-hover table-striped"
                        :columns="columns"
                        :rows="users"
                        :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                        :sort-options="{
                                                        enabled: true,
                                                      }">

                    <div slot="emptystate">
                        <div class="text-center text-muted font-weight-light"><i class="fa fa-exclamation-triangle"></i> <em>Ni podatkov.</em></div>
                    </div>

                    <template slot="table-row" slot-scope="props">
                         <span v-if="props.column.field == 'photo'">
                            <img :src="props.row.photo" class="img" width="60"/>
                        </span>

                        <span v-if="props.column.field == 'first_name'">
                            {{props.row.first_name}}
                        </span>

                        <span v-if="props.column.field == 'last_name'">
                            {{props.row.last_name}}
                        </span>

                        <span v-if="props.column.field == 'email'">
                            {{props.row.email}}
                        </span>

                        <div v-else-if="props.column.field == 'active'">
                            <i v-if="props.row.active" class="fa fa-check-circle"></i>
                            <i v-else class="fa fa-times-circle text-black-50"></i>
                        </div>

                        <span v-else-if="props.column.field == 'id'">

                            <router-link :to="{ name: 'EditUser', params: {id: props.row.id }}"
                                         class="btn btn-primary btn-sm text-white">
                                <i class="fa fa-edit"></i> Uredi</router-link>

                            <a class="btn btn-danger btn-sm text-white ml-1"
                               @click="deleteUserConfirmation(props.row)"><i
                                    class="fa fa-trash"></i> Odstrani</a>
                        </span>
                    </template>
                </vue-good-table>

            </div>


        </div>


        <div class="row">
            <div class="col-md-12 mt-3 mb-5">

                <router-link :to="{ name: 'EditUser' }" class="btn btn-success">
                    <i class="fa fa-plus"></i> Dodaj uporabnika
                </router-link>

            </div>
        </div>
    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'Users',
    components: {
      VueGoodTable,
      Loading
    },
    data () {
      return {
        isLoading: false,
        users: this.$store.getters.getUsers,
        columns: [
          {
            label: 'Slika',
            field: 'photo',
            type: 'text',
            sortable: false,
            width: '70px'
          },
          {
            label: 'Ime',
            field: 'first_name',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Priimek',
            field: 'last_name',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Email',
            field: 'email',
            type: 'text',
            sortable: false,
            width: '300px'
          },
          {
            label: 'Aktivnost',
            field: 'active',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '200px'
          }
        ],
      }
    },
    // firestore () {
    //   return {
    //     users: db.collection('users')
    //   }
    // },
    mounted () {
      const _this = this

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

    },
    methods: {
      deleteUserConfirmation (data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati uporabnika ' + data.first_name + ' ' + data.last_name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteUser(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteUser (id) {
        const _this = this
        _this.isLoading = true
        db.collection('users').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.$router.push('/uporabniki')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting user: ', error)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Users.vue